import { eventNames, useEvents } from 'sly/services/events';

export default function BecomeSlyPartnerBanner({
  page,
  link,
}: {
  page: string;
  link: string;
}) {
  const { events } = useEvents();
  const handleClick = () => {
    if (location)
      events.track(eventNames.ButtonClicked, {
        text: 'Schedule call in footer',
        location: page,
      });
    window.open(link, '_blank');
  };
  return (
    <div className='m-6 flex justify-center rounded-xl bg-viridian-base'>
      <div className='self-stretch md:flex md:max-w-5xl md:items-center md:p-20'>
        <section className='flex flex-col items-center gap-8 py-12 px-6 md:w-[680px] md:p-0'>
          <h2 className='font-t-xxl text-center text-white'>
            Ready to transform your business with Seniorly?
          </h2>

          <button
            className='flex border-spacing-1 justify-center gap-2 self-stretch rounded-lg bg-white p-3 md:self-auto'
            onClick={handleClick}
          >
            <p className='font-t-xs-azo text-viridian-base'>Schedule a call</p>
          </button>
        </section>
      </div>
    </div>
  );
}
